var map = {
	"./detail1.jpg": 79,
	"./detail10.jpg": 80,
	"./detail11.jpg": 81,
	"./detail12.jpg": 82,
	"./detail13.jpg": 83,
	"./detail14.jpg": 84,
	"./detail15.jpg": 85,
	"./detail16.jpg": 86,
	"./detail17.jpg": 87,
	"./detail18.jpg": 88,
	"./detail19.jpg": 89,
	"./detail2.jpg": 90,
	"./detail20.jpg": 91,
	"./detail21.jpg": 92,
	"./detail22.jpg": 93,
	"./detail3.jpg": 94,
	"./detail4.jpg": 95,
	"./detail5.jpg": 96,
	"./detail6.jpg": 97,
	"./detail7.jpg": 98,
	"./detail8.jpg": 99,
	"./detail9.jpg": 100
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 78;